import { useTranslation } from 'react-i18next';
import { toast, useEntityActionsMenu } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { LinkEntityPicker } from '@/features/EventView/components/LinkEntityPicker';
import { linkEntityToEvent } from '@/features/EventView/hooks/useEventEntityLink';
import type { EntityKind } from '@/utils/detection-classes';

interface EventLinkPickerSubmenuProps {
    entityKind: EntityKind;
    sourceEntityId: string;
    eventId: string;
    onLinked?: () => void;
}

export function EventLinkPickerSubmenu({
    entityKind,
    sourceEntityId,
    eventId,
    onLinked,
}: EventLinkPickerSubmenuProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const menu = useEntityActionsMenu();

    const handleLink = async (targetEntityId: string) => {
        try {
            await linkEntityToEvent(eventId, entityKind, targetEntityId);
            toast.success(t('eventView.linkEntity.success'));
            onLinked?.();
        } catch {
            toast.error(t('eventView.linkEntity.errorLink'));
        }
    };

    return (
        <LinkEntityPicker
            entityKind={entityKind}
            sourceEntityId={sourceEntityId}
            onLink={(id) => void handleLink(id)}
            onClose={() => menu?.close()}
            title={t('eventView.entityMenu.replaceLinkedEntity')}
        />
    );
}
